import { render, staticRenderFns } from "./DomainsBrowse.vue?vue&type=template&id=64011ae8&"
import script from "./DomainsBrowse.vue?vue&type=script&lang=js&"
export * from "./DomainsBrowse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports